import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const ideationChatRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ideation/chat",
  component: lazyRouteComponent(
    () => import("@l30/web-atlas/pages/ideation.chat.page"),
    "IdeationChatPage",
  ),
});
